import type { DimensionGuide } from '@app/data/ihs';
import { MessageDescriptor } from '@redbubble/next/intl';
import { ArrayElement } from 'types/ArrayElement';

export enum ProductTypeWithSizeGuide {
  AggroEmu = 'aggro-emu',
  BillowingParachute = 'billowing-parachute',
  BlockishWrapper = 'blockish-wrapper',
  BonzaLamington = 'bonza-lamington',
  CactusBizzo = 'cactus-bizzo',
  ClueyKookaburra = 'cluey-kookaburra',
  FairCuppa = 'fair-cuppa',
  JumpingBoot = 'jumping-boot',
  RipperRissole = 'ripper-rissole',
  SookySanga = 'sooky-sanga',
  UnrealChinwag = 'unreal-chinwag',
  WhingingMagpie = 'whinging-magpie',
  BillowingFalsehood = 'billowing-falsehood',
  BillowingSwelter = 'billowing-swelter',
  CalmWrapper = 'calm-wrapper',
}

export type SizeGuideTable = DimensionGuide;

export type SizeGuideAttribute = ArrayElement<SizeGuideTable['columns']>;
export type SizeGuideRow = ArrayElement<SizeGuideTable['rows']>;
export type RowAttributes = ArrayElement<SizeGuideTable['rows']>['attributes'];

export enum MeasurementUnit {
  In = 'IN',
  Cm = 'CM',
}

export enum Gender {
  Male = 'male',
  Female = 'female',
}

type RequiredDefaultMessageDescription = Omit<
  MessageDescriptor,
  'defaultMessage'
> & {
  defaultMessage: string;
};

export type StringOrIntl = RequiredDefaultMessageDescription | string;

// Hardcoded table content - untranslated

export type PreTranslatedTableColumnValues = {
  dataIndex: string;
  title: StringOrIntl;
  align?: string;
};

export type PreTranslatedTableRowValues = {
  [x: string]: StringOrIntl;
};

export type PreTranslatedTableData = {
  columns: PreTranslatedTableColumnValues[];
  rows: PreTranslatedTableRowValues[];
};

// GetSizeGuide query types - pre-translated

export type TableColumnValues = {
  dataIndex: string;
  title: string;
  align?: string;
};

export type TableRowValues = {
  [x: string]: string;
};

export type TableData = {
  columns: TableColumnValues[];
  rows: TableRowValues[];
};

export type TitleColumnData = {
  [x: string]: {
    name: string;
    value: string;
  };
};

export type DataIndexes = string[];
export interface ProductMeasurementsTableData {
  IN: TableData;
  CM: TableData;
}

type FitIndicator = {
  value: number;
  premium?: boolean;
};

export type HowToChooseSize = {
  imageUrl: string;
  instructions: StringOrIntl[];
};

export type ModelData = {
  imageUrl: string;
  modelSize: StringOrIntl;
  modelMeasurements: StringOrIntl[];
};

export type Model = {
  [key in Gender]?: ModelData;
};

export interface SizeGuideData {
  internationalConversions?: PreTranslatedTableData;
  fitIndicator?: FitIndicator;
  productMeasurements: ProductMeasurementsTableData;
  howToChooseSize?: HowToChooseSize;
  model?: Model;
}

export type PreQuerySizeGuideData = Omit<SizeGuideData, 'productMeasurements'>;
